import { Injectable } from "@angular/core";
import { BehaviorSubject, ReplaySubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class LobbyNavigator {

    public keywordSubject: ReplaySubject<any>;
    public lobbySubject: ReplaySubject<any>;
    private gamesByKeywordSubject = new BehaviorSubject<any[]>([]);
    private allGamesSubject = new BehaviorSubject<any[]>([]);
    private casinoDefaultKeyword: any;
    public hiddenKeywordList: any;
    private keywordList: any;
    public casinoDeepLinkField: any;
    public hasURLQueryParmas: boolean = false;
    private queryParamsData = {
        queryParamsTabName: '',
        queryParamsTabKeywords: '',
        queryParams: {}
      };
    public tabDeepLinkField: any;
    private selectedItem:any;
    public bottomLobbyName: any;
    public bottomLobbySubject: ReplaySubject<any>;
    constructor(
    ) {
        this.keywordSubject = new ReplaySubject<any>();
        this.lobbySubject = new ReplaySubject<any>(1);
        this.bottomLobbySubject = new ReplaySubject<any>(1);
    }

    public setBottomLobbyName(name: any): any {
        this.bottomLobbyName = name;
        this.bottomLobbySubject.next(name);
    }

    public getBottomLobbyName() {
        return this.bottomLobbyName;
    }

    public setKeyword(key: any): any {
        this.setCurrentActiveKeywordItem(key)
        this.keywordSubject.next(key);
    }

    public getKeyword() {
        return this.keywordSubject;
    }

    public async setLobbySubject(lobbyName: string) {
        this.lobbySubject.next(lobbyName);
    }

    public getLobbySubject() {
        return this.lobbySubject;
    }

    public setGamesByKeywordSubject(data: any) {
        this.setAllGameList(data);
        return this.gamesByKeywordSubject.next(data);
    }

    public getGamesByKeywordSubject() {
        return this.gamesByKeywordSubject;
    }

    private setAllGameList(list: any[]): any {
        const allGameList: any[] = [];
        const seenIds = new Set<number>();
        for (const key in list) {
            if (Array.isArray(list[key])) {
                list[key].forEach(game => {
                    if (!seenIds.has(game.id)) {
                        seenIds.add(game.id);
                        allGameList.push(game);
                    }
                });
            }
        }

        this.allGamesSubject.next(allGameList);
    }

    public setKeywordList(list: any) {
        this.keywordList = list;
    }

    public getKeywordList() {
        return this.keywordList;
    }

    public setHiddenKeywordList(list: any) {
        this.hiddenKeywordList = list;
    }

    public getHiddenKeywordList() {
        return this.hiddenKeywordList;
    }

    public getAllGameSubject() {
        return this.allGamesSubject;
    }

    public setCasinoDefaultKeyword(data){
        this.casinoDefaultKeyword = data;
    }

    public getCasinoDefaultKeyword(){
        return this.casinoDefaultKeyword;
    }

    public setCasinoDeepLink(data){
        this.casinoDeepLinkField = data;
    }

    public getCasinoDeepLink(){
        return this.casinoDeepLinkField;
    }

    public setTabDeepLink(data){
        this.tabDeepLinkField = data;
    }

    public getTabDeepLink(){
        return this.tabDeepLinkField;
    }

    public setURLQueryParams(data: boolean){
        this.hasURLQueryParmas = data;
    }

    public getURLQueryParams(){
        return this.hasURLQueryParmas;
    }

    public setQueryParams(data){
        this.queryParamsData.queryParams = data;
    }

    public getQueryParams(){
        return this.queryParamsData.queryParams;
    }

    public setQueryParamsTab(data){
        this.queryParamsData.queryParamsTabName = data;
    }

    public getQueryParamsTab(){
        return this.queryParamsData.queryParamsTabName;
    }

    public setQueryParamsTabKeyword(data){
        this.queryParamsData.queryParamsTabKeywords = data;
    }

    public getQueryParamsTabKeyword(){
        return this.queryParamsData.queryParamsTabKeywords;
    }

    public setCurrentActiveKeywordItem(data: any) {
        this.selectedItem = data;
      }
    
      public getCurrentActiveKeywordItem() {
        return this.selectedItem;
      }

}